import setFieldValue from "@iewc/Store/Handlers/RfqRequestQuote/SetFieldValue";
import { CustomActions, CustomState } from "@iewc/Store/Reducers";
import {
    fields,
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    requestQuoteStyles,
    setRequestFormEffects,
    validateFieldBy
} from "@iewc/Widgets/RfqRequestQuote/FormBaseComponent";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextArea from "@insite/mobius/TextArea";
import Typography from "@insite/mobius/Typography";
import parse from "html-react-parser";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const styles = {
    ...requestQuoteStyles.textFields,
};

const mapStateToProps = (state: CustomState) => ({
    comments: state.customRequestQuoteForm.fieldValues.comments,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const CommentsWidget: React.FC<Props> = ({ fields: widgetFields, comments, setFieldValue: widgetSetFieldValue }) => {
    const { label, hintText, isRequired } = widgetFields;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, comments, "comments", () =>
        validateFieldBy(isRequired, label, comments, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        widgetSetFieldValue({ key: "comments", value: event.target.value });
    };

    return (


            <TextArea
                label={parse(label)}
                required={isRequired}
                placeholder={hintText}
                value={comments || ""}
                error={fieldErrorMessage}
                onChange={fieldChangeHandler}
                rows={5}
            />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CommentsWidget),
    definition: {
        group: "Request a Quote Form" as any,
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "Please include all available information including IEWC part #, MFG part #, length/quantity, product description, gauge, color, etc",
                isRequired: true,
            },
            getRfqFormHintTextBuilt("Please describe your products here."),
            getRfqFormCheckboxBuilt(false),
        ],
    },
};

export default widgetModule;
